@if (createTS()) {
  <div class="history-wrap">
    <p >Aangemaakt op {{createTS() | formatTs: format() }} @if (createUsername()) {
      <span>door {{createUsername()}}</span>
    }</p>
    @if (editTS()) {
      <p>Gewijzigd op {{editTS() | formatTs: format() }} @if (editUsername()) {
        <span>door {{editUsername()}}</span>
      }</p>
    }
  </div>
}